/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addContactsToList } from '../fn/contact-list-api/add-contacts-to-list';
import { AddContactsToList$Params } from '../fn/contact-list-api/add-contacts-to-list';
import { ApiResponseContactList } from '../models/api-response-contact-list';
import { ApiResponseContactListMembersResult } from '../models/api-response-contact-list-members-result';
import { ApiResponseListContactList } from '../models/api-response-list-contact-list';
import { ApiResponsePagedResultContact } from '../models/api-response-paged-result-contact';
import { ApiResponsePagedResultContactList } from '../models/api-response-paged-result-contact-list';
import { ApiResponseVoid } from '../models/api-response-void';
import { archiveContactList } from '../fn/contact-list-api/archive-contact-list';
import { ArchiveContactList$Params } from '../fn/contact-list-api/archive-contact-list';
import { createContactList } from '../fn/contact-list-api/create-contact-list';
import { CreateContactList$Params } from '../fn/contact-list-api/create-contact-list';
import { deleteContactList } from '../fn/contact-list-api/delete-contact-list';
import { DeleteContactList$Params } from '../fn/contact-list-api/delete-contact-list';
import { getContactList } from '../fn/contact-list-api/get-contact-list';
import { GetContactList$Params } from '../fn/contact-list-api/get-contact-list';
import { listContactList } from '../fn/contact-list-api/list-contact-list';
import { ListContactList$Params } from '../fn/contact-list-api/list-contact-list';
import { removeContactsFromList } from '../fn/contact-list-api/remove-contacts-from-list';
import { RemoveContactsFromList$Params } from '../fn/contact-list-api/remove-contacts-from-list';
import { searchContactList } from '../fn/contact-list-api/search-contact-list';
import { SearchContactList$Params } from '../fn/contact-list-api/search-contact-list';
import { searchListContacts } from '../fn/contact-list-api/search-list-contacts';
import { SearchListContacts$Params } from '../fn/contact-list-api/search-list-contacts';
import { updateContactList } from '../fn/contact-list-api/update-contact-list';
import { UpdateContactList$Params } from '../fn/contact-list-api/update-contact-list';

@Injectable({ providedIn: 'root' })
export class ContactListApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getContactList()` */
  static readonly GetContactListPath = '/v1/api/ui/contactList/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getContactList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContactList$Response(params: GetContactList$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseContactList>> {
    return getContactList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getContactList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContactList(params: GetContactList$Params, context?: HttpContext): Observable<ApiResponseContactList> {
    return this.getContactList$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseContactList>): ApiResponseContactList => r.body)
    );
  }

  /** Path part for operation `updateContactList()` */
  static readonly UpdateContactListPath = '/v1/api/ui/contactList/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateContactList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateContactList$Response(params: UpdateContactList$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseContactList>> {
    return updateContactList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateContactList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateContactList(params: UpdateContactList$Params, context?: HttpContext): Observable<ApiResponseContactList> {
    return this.updateContactList$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseContactList>): ApiResponseContactList => r.body)
    );
  }

  /** Path part for operation `deleteContactList()` */
  static readonly DeleteContactListPath = '/v1/api/ui/contactList/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteContactList()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteContactList$Response(params: DeleteContactList$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseVoid>> {
    return deleteContactList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteContactList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteContactList(params: DeleteContactList$Params, context?: HttpContext): Observable<ApiResponseVoid> {
    return this.deleteContactList$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseVoid>): ApiResponseVoid => r.body)
    );
  }

  /** Path part for operation `archiveContactList()` */
  static readonly ArchiveContactListPath = '/v1/api/ui/contactList/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `archiveContactList()` instead.
   *
   * This method doesn't expect any request body.
   */
  archiveContactList$Response(params: ArchiveContactList$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseContactList>> {
    return archiveContactList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `archiveContactList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  archiveContactList(params: ArchiveContactList$Params, context?: HttpContext): Observable<ApiResponseContactList> {
    return this.archiveContactList$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseContactList>): ApiResponseContactList => r.body)
    );
  }

  /** Path part for operation `createContactList()` */
  static readonly CreateContactListPath = '/v1/api/ui/contactList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createContactList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createContactList$Response(params: CreateContactList$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseContactList>> {
    return createContactList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createContactList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createContactList(params: CreateContactList$Params, context?: HttpContext): Observable<ApiResponseContactList> {
    return this.createContactList$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseContactList>): ApiResponseContactList => r.body)
    );
  }

  /** Path part for operation `addContactsToList()` */
  static readonly AddContactsToListPath = '/v1/api/ui/contactList/{ref}/contacts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addContactsToList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addContactsToList$Response(params: AddContactsToList$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseContactListMembersResult>> {
    return addContactsToList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addContactsToList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addContactsToList(params: AddContactsToList$Params, context?: HttpContext): Observable<ApiResponseContactListMembersResult> {
    return this.addContactsToList$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseContactListMembersResult>): ApiResponseContactListMembersResult => r.body)
    );
  }

  /** Path part for operation `searchListContacts()` */
  static readonly SearchListContactsPath = '/v1/api/ui/contactList/{ref}/contacts/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchListContacts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchListContacts$Response(params: SearchListContacts$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultContact>> {
    return searchListContacts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchListContacts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchListContacts(params: SearchListContacts$Params, context?: HttpContext): Observable<ApiResponsePagedResultContact> {
    return this.searchListContacts$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultContact>): ApiResponsePagedResultContact => r.body)
    );
  }

  /** Path part for operation `removeContactsFromList()` */
  static readonly RemoveContactsFromListPath = '/v1/api/ui/contactList/{ref}/contacts/remove';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeContactsFromList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeContactsFromList$Response(params: RemoveContactsFromList$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseContactListMembersResult>> {
    return removeContactsFromList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeContactsFromList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeContactsFromList(params: RemoveContactsFromList$Params, context?: HttpContext): Observable<ApiResponseContactListMembersResult> {
    return this.removeContactsFromList$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseContactListMembersResult>): ApiResponseContactListMembersResult => r.body)
    );
  }

  /** Path part for operation `searchContactList()` */
  static readonly SearchContactListPath = '/v1/api/ui/contactList/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchContactList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchContactList$Response(params: SearchContactList$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultContactList>> {
    return searchContactList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchContactList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchContactList(params: SearchContactList$Params, context?: HttpContext): Observable<ApiResponsePagedResultContactList> {
    return this.searchContactList$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultContactList>): ApiResponsePagedResultContactList => r.body)
    );
  }

  /** Path part for operation `listContactList()` */
  static readonly ListContactListPath = '/v1/api/ui/contactList/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listContactList()` instead.
   *
   * This method doesn't expect any request body.
   */
  listContactList$Response(params: ListContactList$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListContactList>> {
    return listContactList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listContactList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listContactList(params: ListContactList$Params, context?: HttpContext): Observable<ApiResponseListContactList> {
    return this.listContactList$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListContactList>): ApiResponseListContactList => r.body)
    );
  }

}
